/**
 * WF-Option styles for Shadow DOM
 */

import { css } from 'lit';

export const wfOptionStyles = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .wf-option-card {
    display: flex;
    align-items: center;
    gap: var(--wf-spacing-3);
    width: 100%;
    min-height: var(--wf-input-min-height);
    padding: var(--wf-spacing-3);
    background: var(--wf-glass-bg);
    backdrop-filter: blur(var(--wf-glass-blur));
    -webkit-backdrop-filter: blur(var(--wf-glass-blur));
    border: 1px solid var(--wf-glass-border);
    border-radius: var(--wf-radius-md);
    box-shadow: var(--wf-glass-shadow);
    cursor: pointer;
    text-align: left;
    font-family: inherit;
    font-size: var(--wf-font-size-base);
    font-weight: var(--wf-font-weight-input);
    color: var(--wf-color-text);
    transition: border-color 150ms ease, background 150ms ease, transform 100ms ease;
    outline: none;
    box-sizing: border-box;
  }

  .wf-option-card:hover:not(:disabled) {
    border-color: var(--wf-color-primary);
    background: var(--wf-glass-bg-hover);
  }

  .wf-option-card:focus-visible {
    border-color: var(--wf-color-primary);
    box-shadow: 0 0 0 var(--wf-focus-ring-width) var(--wf-focus-ring-primary);
  }

  .wf-option-card[aria-selected='true'] {
    border-color: var(--wf-color-primary);
    background-color: var(--wf-color-primary-light);
  }

  .wf-option-card:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .wf-option-card:active:not(:disabled) {
    transform: scale(0.98);
  }

  .wf-option-card.selecting {
    animation: wf-blink 0.3s ease;
  }

  @keyframes wf-blink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  .wf-option-content {
    flex: 1;
    min-width: 0;
  }

  /* Slotted content styling */
  ::slotted(strong),
  ::slotted(h3),
  ::slotted(h4) {
    display: block;
    font-weight: var(--wf-font-weight-heading);
    margin: 0;
  }

  ::slotted(span),
  ::slotted(p) {
    display: block;
    font-size: var(--wf-font-size-sm);
    color: var(--wf-color-text-muted);
    margin: var(--wf-spacing-1) 0 0 0;
  }
`;
